﻿import $ from "jquery";
import specs from "./fullSpecs";

export default function (options) {

	const ep = $(`#${options.inlineContentId}`);

	specs(ep, options);
}
